import React, {useState} from 'react';
import {Provider} from 'react-redux'
import '../node_modules/material-components-web/dist/material-components-web.min.css';
import styled from 'styled-components';

import {ThemeProvider, injectGlobal} from 'styled-components';

import './App.css';
import {LangProvider} from './i18n';
import DefaultTheme from './Assets/Theme';
import WebFont from 'webfontloader'

import {Router} from "react-router-dom";
import {Switch, Route} from 'react-router'

import store, {history} from './Store'
import PageTransition from 'react-router-page-transition';

import RedirectToContext from './Containers/RedirectToContext/RedirectToContext';
import Welcome from './Containers/Welcome/Welcome';
import Error from "./Containers/Error/Error";
import PickServices from "./Containers/PickServices/PickServices";
import PickEmployee from "./Containers/PickEmployee/PickEmployee";
import PickTime from "./Containers/PickTime/PickTime";
import ResultsPage from "./Containers/ResultsPage/ResultsPage";
import SuccessPage from "./Containers/Success/SuccessPage";
import Identify from "./Containers/Identify/Identify";
import Payment from "./Containers/Payment/Payment";
import Validate from "./Containers/Identify/Validate";
import {resetWizard} from "./Containers/Welcome/Actions";
import {push} from "connected-react-router";
import {getSafely} from "@tomeravni/easybizy-js-common/common";
import {resolveCustomerToken} from "./Common/Helpers";
import {isNonEmptyString} from "@tomeravni/easybizy-js-common/common";
import {generateCustomFontCssString} from "./Common/CustomFont";

WebFont.load({
    google: {
        families: ['Roboto:300,500,700', 'Material Icons', 'Arimo:100,200,300,400,400i,700,700i&amp;subset=hebrew']
    }
});

const InheritDiv = styled.div`
    width: inherit;
    height: inherit;
    background-color: ${p => p.theme.colors.desktopBackground};

    .switch-wrapper, .switch-wrapper > div {
        width: inherit;
        height: inherit;
    }

    @media only screen and (min-width: 550px) and (min-height: 500px) {
        padding: 5vh;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;

        .switch-wrapper {
            background-color: ${p => p.theme.colors.surfaceFront};
            max-width: 550px;
            margin: 0 auto;
            -webkit-box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.28);
            -moz-box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.28);
            box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.28);
            border-radius: 5px;
        }
    }
`;

let latestVisibleDate = null

const App = () => {

    const windowTheme = window.theme || {...DefaultTheme};
    const [theme] = useState(windowTheme);
    let toInject = '';
    let fontToInject = '';
    const customFont = getSafely(['properties', 'fontFamily'], windowTheme);
    const isRounded = !!getSafely(['properties', 'roundedPrimary'], windowTheme);
    const customFontAsString = generateCustomFontCssString(customFont);
    let defaultFontFamily = `'Heebo', 'Arimo', 'SourceSansPro', 'LiberationSans', "Helvetica Neue", Helvetica, Arial, sans-serif`;
    if (isNonEmptyString(customFontAsString)) {
        defaultFontFamily = `'CustomFont', ${defaultFontFamily}`;
        fontToInject += `
        ${customFontAsString}
        
        :root {
          --app-font: ${defaultFontFamily};
        }
        
        #easybizy-online-scheduling-app .mdc-checkbox__checkmark {
            color: ${windowTheme.colors.primaryColor};
        }
        
        #easybizy-online-scheduling-app .mdc-checkbox__background {
            border-color: ${windowTheme.colors.modalPrimaryText};
        }
        
        `;
    } else {
        fontToInject = `
        :root {
            --app-font: ${defaultFontFamily};
        }
        `
    }

    toInject += isRounded ? `
    #easybizy-online-scheduling-app .mdc-button {
        border-radius: 30px;
    }
    
    #easybizy-online-scheduling-app div:not(.mdc-dialog__footer) > .mdc-button:not(.mdc--transparent) { 
        background-color: ${windowTheme.colors.primaryColor};
        color:  ${windowTheme.colors.safeText};
    }` : '';

    injectGlobal`
        ${fontToInject}
        html {
            color: ${windowTheme.colors.safeText};
            font-family: ${defaultFontFamily};
        }

        #easybizy-online-scheduling-app .mdc-dialog__header__title, #easybizy-online-scheduling-app .mdc-dialog__body, #easybizy-online-scheduling-app .mdc-button, #easybizy-online-scheduling-app .MuiTypography-root {
            font-family: var(--app-font);
        }

        .mdc-form-field {
            font-family: var(--app-font) !important;
        }

        :root {
            --mdc-theme-primary: ${windowTheme.colors.primaryColor};
            --mdc-theme-secondary: ${windowTheme.colors.safeText};
        }

        .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate) ~ .mdc-checkbox__background {
            border-color: ${windowTheme.colors.safeText};
        }

        #easybizy-online-scheduling-app .mdc-dialog__header__title {
            color: ${windowTheme.colors.modalPrimaryText};
        }

        ${toInject}
    `
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <InheritDiv className="top-container">
                    <LangProvider>
                        <Router history={history}>
                            <Route
                                render={({location}) => {
                                    document.addEventListener('visibilitychange', function (ev) {
                                        if (document.visibilityState === 'visible') {
                                            if (latestVisibleDate) {
                                                const state = store.getState();
                                                const config = getSafely(['schedule', 'config'], state);
                                                const contextName = getSafely(['ContextName'], config);
                                                const customerToken = resolveCustomerToken(config);
                                                if (!isNonEmptyString(contextName)) {
                                                    return
                                                }

                                                const adaptedPath = `/${contextName.toLowerCase()}${isNonEmptyString(customerToken) ? `/${customerToken}` : ''}/welcome`;
                                                const diffMs = (new Date() - latestVisibleDate); // milliseconds
                                                const diffMinutes = Math.round(((diffMs % 86400000) % 3600000) / 60000);
                                                if (diffMinutes > 10) { // Keep 10 minutes.
                                                    latestVisibleDate = null
                                                    store.dispatch(resetWizard());
                                                    store.dispatch(push(
                                                        {
                                                            search: '',
                                                            pathname: adaptedPath
                                                        }
                                                    ));
                                                }
                                            }

                                        } else {
                                            latestVisibleDate = new Date();
                                        }

                                    });

                                    return (
                                        <PageTransition timeout={440} transitionAction={history.action}>
                                            <Switch location={location}>
                                                <Route exact path="/" component={RedirectToContext}/>
                                                <Route exact path="/error" component={Error}/>
                                                <Route exact path="/:context/error" component={Error}/>
                                                <Route exact path="/:context/:customer/error" component={Error}/>
                                                <Route exact path="/:oldRoute" component={RedirectToContext}/>
                                                <Route exact path="/:context/welcome" component={Welcome}/>
                                                <Route exact path="/:context/:customer/welcome" component={Welcome}/>
                                                <Route exact path="/:context/identify" component={Identify}/>
                                                <Route exact path="/:context/:customer/identify" component={Identify}/>
                                                <Route exact path="/:context/validate" component={Validate}/>
                                                <Route exact path="/:context/:customer" component={Welcome}/>
                                                <Route exact path="/:context/:customer/pick-services"
                                                       component={PickServices}/>
                                                <Route exact path="/:context/:customer/pick-employee"
                                                       component={PickEmployee}/>
                                                <Route exact path="/:context/:customer/pick-time"
                                                       component={PickTime}/>
                                                <Route exact path="/:context/:customer/results"
                                                       component={ResultsPage}/>
                                                <Route exact path="/:context/:customer/payment" component={Payment}/>
                                                <Route exact path="/:context/:customer/success"
                                                       component={SuccessPage}/>
                                                <Route component={Error}/>
                                            </Switch>
                                        </PageTransition>

                                    )
                                }
                                }
                            />
                        </Router>
                    </LangProvider>
                </InheritDiv>
            </ThemeProvider>
        </Provider>
    );
};

export default App;
